import axios from 'axios';
import { GeneralIds, ModelTypes } from 'types/types';
import { ROOT_URL, API_VERSION } from 'constants/index';
import { getURLByModelType } from 'api/models';

export async function remove({
  type,
  ids,
}: {
  type: ModelTypes;
  ids?: GeneralIds;
}) {
  if (!ids?.id) {
    throw new Error('ID is required for delete');
  }

  const response = await axios({
    method: 'DELETE',
    url: `${ROOT_URL}/${API_VERSION}/${getURLByModelType(type, ids)}`,
  });
  return response;
}
